export const PRODUCT_SWITCHER = 'js-product-switcher';
export const PRODUCT_SWITCHER_CONTAINER = 'js-above-the-fold-product-card';
export const PRODUCT_SWITCHER_BOTTLE_CONTAINER = 'js-product-bottle';
